import { render, staticRenderFns } from "./Divcard.vue?vue&type=template&id=e45c76b4&scoped=true&"
import script from "./Divcard.vue?vue&type=script&lang=js&"
export * from "./Divcard.vue?vue&type=script&lang=js&"
import style0 from "./Divcard.vue?vue&type=style&index=0&id=e45c76b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45c76b4",
  null
  
)

export default component.exports